import axios from "axios";
import CommonApi from "./CommonApi";


export default class ToDoApi {
    static async addImage(image, house, floor){

        const FormData=new window.FormData();

        FormData.append('image', image,'1.jpg')
        FormData.append('house', house)
        FormData.append('floor', floor)
        const res=await axios.post( CommonApi.getHost()+"/toDo/addImage",  FormData)
        return res.data;
    }
}